import { MapPin, X, Check } from "@phosphor-icons/react";
import { getIndochinaTime } from "../Home";
import axios from "axios";
import { toast } from "sonner";

const AdminCardHistory = ({ cb, api }) => {
  const thoseDay = new Date(cb.check_in);
  const dayToday = thoseDay.toLocaleDateString("en-GB", { day: "numeric" });
  const dayDay = thoseDay.toLocaleDateString("en-GB", { weekday: "short" });

  const handleX = async (e) => {
    e.preventDefault();
    console.log("🚀 ~ handleX ~ cb.id:", cb.id)
    try {
        await axios.delete(`${api}/${cb.id}`);
      toast.success("Data berhasil di tolak");
      window.location.reload()
    } catch (err) {
      toast.error("Data kgagal di tolak");
      console.error("ERROR 505: " + err);
    }
  };
  const handleCheckList = async (e) => {
    e.preventDefault();
    try {
      await axios.put(api, {
        id: cb.id,
      });
      toast.success("Data berhasil di setujui");
      
      window.location.reload()
    } catch (err) {
      toast.error("Data gagal di setujui");
      console.error("ERROR 505: " + err);
    }
  };

  return (
    <div className="p-2 rounded-lg shadow flex flex-col gap-2 bg-slate-50">
      <div className="border-b border-gray-400 text-black font-semibold">
        {cb.name}
      </div>
      <div className="w-full flex gap-6 justify-between">
        <div className="px-6 py-2 justify-center items-center flex flex-col text-white bg-green-700 rounded-lg gap-3">
          <p className={"text-2xl font-bold "}>{dayToday}</p>
          <p className="text-sm font-light">{dayDay}</p>
        </div>
        {/* BUILD TIME STATUS */}
        <div className={`pt-1.5 flex  pe-2 gap-2 flex-col w-full `}>
          <div className="flex justify-evenly ">
            <div className="flex flex-col gap-0.5 items-center justify-center">
              <p className="text-md font-semibold">
                {getIndochinaTime(cb.check_in)}
              </p>
              <p className="text-xs font-normal text-gray-400">Check In</p>
            </div>
          </div>
          <div className="flex gap-1.5 justify-center items-center">
            <MapPin weight="fill" size={16} className="text-green-700" />
            <p className="font-semibold whitespace-nowrap text-xs">
              {cb.location}
            </p>
          </div>
        </div>
        { api && (
          <div className="justify-center flex-col-reverse items-center flex text-white rounded-lg gap-2">
            <div
              onClick={handleX}
              className={
                "text-lg font-extrabold min-w-8 cursor-pointer min-h-8 bg-gray-200 text-gray-400 rounded-lg flex justify-center items-center "
              }
            >
              <X weight="bold" />{" "}
            </div>
            <div
              onClick={handleCheckList}
              className="text-lg font-extrabold min-w-8 cursor-pointer min-h-8 bg-green-700 rounded-lg flex justify-center items-center text-white  "
            >
              <Check weight="bold" />{" "}
            </div>
          </div>
        ) }
      </div>
    </div>
  );
};

export default AdminCardHistory;
